/**
 * This file contains shared constants for the Marketplace components.
 * The intention is to have a single source of truth for these constants
 * so they can remain consistent across the app.
 */
import {
  BabyIcon,
  BedIcon,
  BoneIcon,
  BrainIcon,
  DumbbellIcon,
  HeartHandshakeIcon,
  HeartPlusIcon,
  MarsIcon,
  ShapesIcon,
  TrendingDown,
  VenusIcon,
  VideoIcon
} from 'lucide-react'
import type React from 'react'
import { createContext } from 'react'

import { Balance } from './Balance'
import * as events from './events'
import { type MarketplaceProductCategory, type SessionContextType } from './types'

export const PRICE_QUALIFIER_TEXT = 'from'

// Merchant names
export const MERCHANT_NAMES = {
  HAPPIEST_BABY: 'Happiest Baby',
  TRUEMED: 'Truemed',
  FUNCTION: 'Function',
} as const

export const PRODUCT_CATEGORIES: { category: MarketplaceProductCategory, Icon: React.ElementType, displayName: string }[] = [
  { category: 'All', Icon: ShapesIcon, displayName: 'All' },
  { category: 'Weightloss', Icon: TrendingDown, displayName: 'Weight loss' },
  { category: 'Fitness', Icon: DumbbellIcon, displayName: 'Fitness' },
  { category: 'Preventative care', Icon: HeartHandshakeIcon, displayName: 'Preventive care' },
  { category: 'Sleep', Icon: BedIcon, displayName: 'Sleep' },
  { category: 'Mental health', Icon: BrainIcon, displayName: 'Mental health' },
  { category: 'Men\'s health', Icon: MarsIcon, displayName: 'Men\'s health' },
  { category: 'Women\'s health', Icon: VenusIcon, displayName: 'Women\'s health' },
  { category: 'Fertility', Icon: HeartPlusIcon, displayName: 'Fertility' },
  { category: 'Telehealth', Icon: VideoIcon, displayName: 'Telehealth' },
  { category: 'Pediatrics', Icon: BabyIcon, displayName: 'Pediatrics' },
  { category: 'Musculoskeletal', Icon: BoneIcon, displayName: 'Musculoskeletal' },
]

export const SessionContext = createContext<SessionContextType>({
  id: null,
  employerId: null,
  balance: undefined,
  isAuthenticated: false,
  publicView: true,
  publicReferralUrl: '',
})

export { Balance, events }
